import React, { Component } from "react";
import { ajaxManage } from "utils/common";
import { message, Tabs } from 'antd';
import ListAccount from "./listAccount/index";
import AddAccount from "./addAccount/index";
import "./index.less";
//图片
import Logo from "images/logo.png";

const TabPane = Tabs.TabPane;

class App extends Component {
	state = {
		year: new Date().getFullYear()
	}

	logout = () => {
		ajaxManage({
			url: "/sys/logout",
			data: this.state.params
		}).then(res => {
			message.destroy();
			message.success('退出登录成功！', () => {
				this.props.history.replace("/console/login");
			});
		})
	}

  	render() {
    	const { year } = this.state;

    	return (
    		<div className="video-app-wrap list-wrap">
	            <div className="video-header-wrap">
	            	<div className="list-header">
		            	<img src={Logo} />
	    				<p className="list-header-title">视频管理系统</p>
	    				<div className="list-header-logout" onClick={this.logout}>退出登录</div>
	            	</div>
	            </div>
	            <div className="video-main-wrap">
	            	<div className="video-main-tab">
		            	<Tabs>
					    	<TabPane tab="视频流水页" key="1">
				            	<ListAccount />
					    	</TabPane>
						    <TabPane tab="快速增加账号" key="2">
						    	<AddAccount />
						    </TabPane>
					  	</Tabs>
	            	</div>
	            	<p className="list-copyright">版权所有@2007-{year} 大易云计算有限公司</p>
	            </div>
	        </div>
		);
	}
}

export default App;